export default __webpack_public_path__ + "static/media/m11.e3804b86.png";